import type { GricsImportKind } from '@/sdk/model';

/**
 * Where the GRICS imports live since #989, and who may run them — shared by the imports page and
 * by the four pages that used to host their own import dialog and now link here instead.
 */

/** The one permission every import route checks. The buttons ask for it too, or they open a 403. */
export const GRICS_IMPORT_PERMISSION = 'Parcours.GricsImport.Administrateur';

export const GRICS_IMPORTS_ROUTE_NAME = 'gestion-importations-grics';

/** The page's tabs, as `useUrlTab` writes them in the hash (`#select=eleves`), in display order. */
export const GRICS_IMPORT_TABS = ['centres', 'enseignants', 'eleves', 'frequentations'] as const;
export type GricsImportTab = (typeof GRICS_IMPORT_TABS)[number];

export const GRICS_IMPORT_TAB_OF_KIND: Record<GricsImportKind, GricsImportTab> = {
  Centres: 'centres',
  Teachers: 'enseignants',
  Students: 'eleves',
  Frequentations: 'frequentations',
};

export function hasGricsImportPermission(permissions: readonly string[] | null | undefined): boolean {
  return permissions?.includes(GRICS_IMPORT_PERMISSION) ?? false;
}

/**
 * The link to one import's tab. The first tab is the page's default, which `useUrlTab` keeps out
 * of the URL — so is it here, or the link would not match the address the page settles on.
 */
export function gricsImportLink(kind: GricsImportKind): { name: string; hash?: string } {
  const tab = GRICS_IMPORT_TAB_OF_KIND[kind];
  return tab === GRICS_IMPORT_TABS[0]
    ? { name: GRICS_IMPORTS_ROUTE_NAME }
    : { name: GRICS_IMPORTS_ROUTE_NAME, hash: `#select=${tab}` };
}
